import { devLog } from '@/lib/logging';

export type DataLayerValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | Record<string, unknown>
  | DataLayerValue[];

type PushToDataLayerProps = {
  eventName: string;
  ecommerce?: {
    currency?: string;
    transaction_id?: string;
    value?: number;
    items?: Array<{
      item_id?: string;
      item_name?: string;
      quantity?: number;
      price?: number;
    }>;
  };
  rest?: Record<string, unknown>;
};

// Allow for flexible data that can be any serializable object
export type SerializableValue =
  string | number | boolean | null | undefined | object;

type PushFormEventToDataLayerProps = {
  eventName: string;
  form_type?: 'contact_us' | 'sign_up';
  data?: Record<string, unknown>;
};

// Helper function to safely convert structured objects to data layer format
export function toDataLayerData(obj: unknown): {
  [key: string]: SerializableValue;
} {
  return obj as { [key: string]: SerializableValue };
}

export function pushToDataLayer({
  eventName,
  ecommerce,
  rest = {},
}: PushToDataLayerProps) {
  if (typeof window !== 'undefined' && window.dataLayer?.push) {
    const event = {
      event: eventName,
      ...(ecommerce ? { ecommerce } : {}),
      ...rest,
    };

    try {
      window.dataLayer.push(event);
      devLog(`Event "${eventName}" pushed to dataLayer successfully`, event);
    } catch (error) {
      console.error('Error preparing dataLayer event:', error);
    }
  } else {
    console.warn('dataLayer not available on window');
  }
}

export function pushFormEventToDataLayer({
  eventName,
  form_type,
  data,
}: PushFormEventToDataLayerProps) {
  const rest = {
    ...(form_type ? { form_type } : {}),
    ...(data ? { data } : {}),
  };

  pushToDataLayer({ eventName, rest });
}
